@for (filter of selectedFilters$ | async; track filter.id) {
	<hmf-global-chips
		class="filter-chip hmf-mr-xs"
		[label]="filter.label"
		[ariaLabel]="filter.name"
		[showCancelSign]="true"
		(click)="clearOne(filter)"
		(keydown.enter)="clearOne(filter)">
	</hmf-global-chips>
}

@if (isHighlyRatedReviewsEnabled) {
	@let selectedProCon = selectedProCon$ | async;
	@if (selectedProCon?.feature) {
		<hmf-global-chips
			class="filter-chip hmf-mr-xs"
			[label]="selectedProCon.feature | titlecase"
			[ariaLabel]="selectedProCon.feature"
			[showCancelSign]="true"
			(click)="clearOne(selectedProCon)"
			(keydown.enter)="clearOne(selectedProCon)">
		</hmf-global-chips>
	}
}

<a
	hmf-text-link
	class="filters-chips-clear hmf-text-decoration-underline hmf-mr-xs"
	type="button"
	altText="Clear all chips"
	dataEm="dateEM_tag"
	ariaLabel="clear-all-chips"
	(click)="clearAll($event)">
	Clear All
</a>